export const getColors = (param, value, ticketAgeing5Days, isPaidFree = "") => {
    if (param === 'Calls (Success%)') {
        const numberPart = parseInt(value.match(/^\d+/)[0]);
        const percentagePart = parseInt(value.match(/\d+(?=%)/)[0]);
        if(numberPart === 0){
            return "black"
        }else{
            if (percentagePart <= 50) {
                return "Red"
            } else if (percentagePart > 50 && percentagePart <= 70) {
                return "black"
            } else {
                return "Green"
            }
        }
    } else if (param === "BL Active") {
        if(parseInt(value.split(' ')[0]) === 0 ){
            if(isPaidFree === 'Paid | '){
                return 'Red'
            }else{
                return 'black'
            }
        }else if (parseInt(value.split(' ')[0]) > 0 && parseInt(value.split(' ')[0]) < 5) {
            return "Red"
        } else if (parseInt(value.split(' ')[0]) >= 5 && parseInt(value.split(' ')[0]) <= 10) {
            return "black"
        } else {
            return "Green"
        }
    } else if (param === "BL NI") {
        if(value === 0){
            return "black"
        }else if (value >= 5) {
            return "Red"
        } else if (value >= 2 && value <= 4) {
            return "black"
        } else {
            return "Green"
        }
    } else if (param === "A Rank") {
        if(value === 0 ){
            if(isPaidFree === 'Paid | '){
                return 'Red'
            }else{
                return 'black'
            }
        }else if (value > 0 && value < 3) {
            return "Red"
        } else if (value >= 3 && value <= 5) {
            return "black"
        } else {
            return "Green"
        }
    } else if (param === "D Rank") {
        if(value === 0){
            return "black"
        }else if (value > 3) {
            return "Red"
        } else if (value >= 2 && value <= 3) {
            return "black"
        } else {
            return "Green"
        }
    } else if (param === "Catalog Score") {
        const catalogValue = value.replace('%', '')
        if(parseInt(catalogValue) === 0){
            return "black"
        }else if (parseInt(catalogValue) > 0 && parseInt(catalogValue) <= 50) {
            return "Red"
        } else if (parseInt(catalogValue) > 50 && parseInt(catalogValue) <= 70) {
            return "black"
        } else {
            return "Green"
        }
    } else if (param === "Avg. Rating") {
        if(value === "NA"){
            return "black"
        }else if (value < 3) {
            return "Red"
        } else if (value >= 3 && value < 5) {
            return "black"
        } else {
            return "Green"
        }
    } else if (param === 'Products') {
        return 'black';
    } else if (param === "Categories") {
        if(value === 0){
            return 'black';
        }else if (value < 5) {
            return "Red"
        } else if (value >= 5 && value <= 8) {
            return "black"
        } else {
            return "Green"
        }
    } else if (param === "No.s Mapped") {
        if (value === 0) {
            return "black"
        } else if (value > 0) {
            return "Green"
        }
    } else if (param === "Negative Feedback") {
        if (value === 0) {
            return "black"
        } else if (value > 0) {
            return "Red"
        }
    } else if (param === "Enquiry") {
        return 'black';
    } else if (param === "Lead Mgr. Active") {
        if(value === 0 ){
            if(isPaidFree === 'Paid | '){
                return 'Red'
            }else{
                return 'black'
            }
        }else if (value > 0 && value <= 7) {
            return "Red"
        } else if (value >= 8 && value <= 14) {
            return "Black"
        } else if (value > 14) {
            return "Green"
        }
    } else if (param === "Tickets WIP/Closed") {
        if (ticketAgeing5Days === true) {
            return "Red"
        } else {
            return "black"
        }
    }
    else {
        return "black"
    }

}

export const buyerKPIsColorCoding = (param, value) => {
    if (param === "BS Conflict Tickets") {
        if (value !== "0/0") {
            return "red"
        }
    }
}